export default __webpack_public_path__ + "static/media/image-crew.92a07b5e.jpg";